
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function ($, _c, undefined) {
	'use strict';

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.

	var Sage = {
		
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				$('.scrollto').on('click', function (event){
					event.preventDefault();
					var section = $(this).attr('href');
					$('html, body').animate({
			            scrollTop: $(section).offset().top
			        }, 1000);
				});

				var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
				if (iOS === true){
					$('body').addClass('ios');
				}

				var isSafari = window.safari !== undefined;
				if (isSafari) {
					$('body').addClass('safari');
				}

                var didScroll;
                var lastScrollTop = 0;
                var delta = 5;
                var navbarHeight = $('header').outerHeight();

                $(window).scroll(function (event) {
                    didScroll = true;
                });

				function hasScrolled() {
                    var st = $(window).scrollTop();
                    if (Math.abs(lastScrollTop - st) <= delta) {
						return;
					}
                    if (st > lastScrollTop && st > navbarHeight) {
                        $('.hamburger').removeClass('nav-down').addClass('nav-up');
                    } else {
                        if (st + $(window).height() < $(document).height()) {
                            $('.hamburger').removeClass('nav-up').addClass('nav-down');
                        }
                    }
                    lastScrollTop = st;
				}
				
                setInterval(function () {
                    if (didScroll) {
                        hasScrolled();
                        didScroll = false;
                    }
                }, 250);

				if ($('.reveal').length > 0){
			        $('.reveal').each(function(e){
			            var reveal = $(this);
			            var waypoint_reveal = new Waypoint({
			                element: reveal[0],
			                handler: function(direction) {
			                    if (direction === 'down'){
			                        reveal.addClass('on');
			                    }
			                },
			                offset: '77%'
			            });
			        });
			    }

				$('.hamburger').on('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					if ($(this).hasClass('is-active')) {
						$('.nav').addClass('on');
						$('.hamburger span').hide();
						$('.logo').addClass('open-nav');
					} else {
						$('.nav').removeClass('on');
						$('.hamburger span').show();
						$('.logo').removeClass('open-nav');
					}
				});
				$('.nav li a').on('mouseenter', function (event){
					var photo = $(this).parent().data('photo');
					$('.photo').removeClass('on');
					$('.photo-'+photo).addClass('on');
					$('.photos .overlay').addClass('on');
				}).on('mouseleave', function (event){
					$('.photo').removeClass('on');
					$('.photos .overlay').removeClass('on');
				});
				$('.nav').on('click', function (event){
					event.stopPropagation();
				});

				$('.nav li a').on('mouseenter', function(){
					$('.nav li a').addClass('off');
					$(this).removeClass('off');
				}).on('mouseleave', function(){
					$('.nav li a').removeClass('off');
				});

				function fallback(video){
					var img = video.querySelector('img');
					if (img){
						video.parentNode.replaceChild(img, video);
					}
				}

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Home page
		'page_template_template_home': {
			init: function() {
				// JavaScript to be fired on all pages

				function fallback(video){
					var img = video.querySelector('img');
					if (img){
						video.parentNode.replaceChild(img, video);
					}
				}
				
				var menu_swiper = new Swiper('.menu-cnt .swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					loop: false,
					speed: 1200,
					spaceBetween: 0,
					centeredSlides: true,
					simulateTouch: true,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {},
				});

				function createFullPage(){
					
					$('#fullpage').fullpage({
						//Navigation
						lockAnchors: true,
						navigation: false,

						//Scrolling
						css3: true,
						scrollingSpeed: 700,
						autoScrolling: true,
						fitToSection: true,
						fitToSectionDelay: 1000,
						scrollBar: false,
						easing: 'easeInOutCubic',
						easingcss3: 'ease',
						loopBottom: false,
						loopTop: false,
						loopHorizontal: true,
						continuousVertical: false,
						continuousHorizontal: false,
						scrollHorizontally: false,
						interlockedSlides: false,
						dragAndMove: false,
						offsetSections: false,
						resetSliders: false,
						fadingEffect: false,
						scrollOverflow: false,
						scrollOverflowReset: false,
						scrollOverflowOptions: null,
						touchSensitivity: 15,
						normalScrollElementTouchThreshold: 5,
						bigSectionsDestination: null,

						//Accessibility
						keyboardScrolling: true,
						animateAnchor: true,
						recordHistory: false,

						//Design
						controlArrows: true,
						verticalCentered: true,
						responsiveWidth: 980,
						responsiveHeight: 0,
						responsiveSlides: false,
						parallax: false,
						parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

						//Custom selectors
						sectionSelector: '.section',
						slideSelector: '.slide',
						lazyLoading: false,

						//events
						onLeave: function(index, nextIndex, direction){
							if (index > 0){
								$('.menu-cnt').addClass('active');
							}
							if (direction === 'down'){
								menu_swiper.slideTo(index);
								if (!$('#section'+nextIndex).hasClass('ran')){
									$('#section'+nextIndex).addClass('ran');
								}
							}
							if (direction === 'up'){
								nextIndex = nextIndex - 1;
								menu_swiper.slideTo(nextIndex);
								if (nextIndex < 1){
									$('.menu-cnt').removeClass('active');
								}
								if (!$('#section'+nextIndex).hasClass('ran')){
									$('#section'+nextIndex).addClass('ran');
								}
							}
							if (index !== 3){
								$('#section4 .project').removeClass('active');
								$('#section4 .bg-main').show();
								$('#section4 .bg').removeClass('active');
								$('#section4 .hover-list .swiper-slide a').removeClass('active');
								$('#section4 .hover-list .swiper-slide a').removeClass('off');
							}
							if (index === 6){
								$('.home-page #section7 .bg').addClass('on');
							}
						},
						afterLoad: function(anchorLink, index){
							if (index > 1){
								$('.menu-cnt').addClass('active');
							} else {
								$('.menu-cnt').removeClass('active');
							}
							index = index - 1;
							menu_swiper.slideTo(index);
											
							if ($('#fullpage').hasClass('intro')){
								$('.loader').fadeOut(400);
								$('.section').removeClass('fp-section');
								$('.hamburger').addClass('on');
								$('#fullpage').addClass('active');
								setTimeout(function(){
									$('#intro-1').addClass('active');
								}, 400);
								setTimeout(function(){
									$('#intro-1').addClass('off');
								}, 3000);
								setTimeout(function(){
									$('#intro-2').addClass('active');
								}, 4000);
								setTimeout(function(){
									$('#intro-2').addClass('off');
								}, 7000);
								setTimeout(function(){
									$('#intro-3').addClass('active');
								}, 8000);
								setTimeout(function(){
									$('#intro-3').addClass('off');
								}, 11000);
								setTimeout(function(){
									$('#intro-4').addClass('active');
								}, 12000);
								setTimeout(function(){
									$('#intro-4').addClass('off');
								}, 15000);
								setTimeout(function(){
									$('.hero').addClass('active');
									$('.hero .overlay').addClass('active');
									$('#section1 figure').addClass('active');
									$('.logo').addClass('on');
									$('.hamburger').addClass('on');
									$('.nav').addClass('active');
									$('.menu-cnt').addClass('on');
									$('#fullpage').removeClass('intro');
									$('.skip-intro').hide();
									$('.section').addClass('fp-section');
								}, 16000);
							}
							
						},
						afterRender: function(){},
						afterResize: function(){},
						afterResponsive: function(isResponsive){},
					});

					var scrollDelay = 700;
					
					$.fn.fullpage.setAutoScrolling = function(value){
						var element = $('.section.active');
						$('html, body').css({
							'overflow' : 'hidden',
							'height' : '100%'
						});
						if(element.length){
							var translate3d = 'translate3d(0px, -' + element.position().top + 'px, 0px)';	
						}
					};
				}

				$('.menu-cnt #menu li a').on('click', function (event){
					event.preventDefault();
					var index = $(this).data('index');
					$.fn.fullpage.moveTo(index);
				});

				$(window).on('load', function(){
					createFullPage();
					$('#fullpage').addClass('on');
				});

				$('.skip-intro').on('click', function (event){
					event.preventDefault();
					$('.intro').hide();
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('#section1 figure').addClass('active');
					$('.logo').addClass('on');
					$('.hamburger').addClass('on');
					$('.nav').addClass('active');
					$('.menu-cnt').addClass('on');
					$('#fullpage').removeClass('intro');
					$('.skip-intro').hide();
					$('.section').addClass('fp-section');
				});

				$('#section3 .hover-links li a').on('mouseenter', function(){
					var photo = $(this).data('hover');
					$('.photos-cnt').addClass('active');
					$('.photo-'+photo).addClass('active');
					$('#text-box-'+photo).addClass('active');
					$('#section3 .hover-links li a').addClass('off');
					$(this).removeClass('off');
					$(this).addClass('active');
				}).on('mouseleave', function(){
					$('.photos-cnt').removeClass('active');
					$('.photo').removeClass('active');
					$('.text-box').removeClass('active');
					$('#section3 .hover-links li a').removeClass('off');
					$('#section3 .hover-links li a').removeClass('active');
				});

				$('#section3 .hover-links li a').on('click', function (event){
					event.preventDefault();
				});

				var slides_total = $('.hover-list .swiper-container .swiper-slide').length;
				if (slides_total < 7){
					$('.hover-list .prev').addClass('disabled');
					$('.hover-list .next').addClass('disabled');
				}
				var projects_swiper = new Swiper('.hover-list .swiper-container', {
					autoplay: false,
					slidesPerView: 6,
					direction: 'vertical',
					loop: false,
					speed: 1200,
					spaceBetween: 0,
					centeredSlides: false,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {
						
					},
					on: {
						init: function () {
							$('.hover-list .prev').addClass('off');
						},
						slideChange: function () {
							if (this.activeIndex < 1){
								$('.hover-list .prev').addClass('off');
							} else {
								$('.hover-list .prev').removeClass('off');
							}
							if (this.activeIndex >= slides_total - 6){
								$('.hover-list .next').addClass('off');
							} else {
								$('.hover-list .next').removeClass('off');
							}
						},
					}
				});

				$('.hover-list .prev').on('click', function (event){
					event.preventDefault();
					projects_swiper.slidePrev();
				});

				$('.hover-list .next').on('click', function (event){
					event.preventDefault();
					projects_swiper.slideNext();
				});

				function setMask(){
					if ($('.projects-cnt .project').hasClass('active')){
						var mask_offset = $('.projects-cnt .project.active .project-photos').position().left;
						$('.home-page #section4 .bg-overlay').css('clip-path', 'polygon(830px 236px,100% 236px,100% 554px,635px 554px,'+mask_offset+'px 554px,'+mask_offset+'px 236px)');						
					}
				}

				$(window).on('resize', function(){
					setMask();
				});

				$('#section4 .hover-list .swiper-slide a').addClass('off');
				$('#section4 .hover-list .swiper-slide a').on('mouseenter', function(){
					var photo = $(this).data('hover');
					$('.project').removeClass('active');
					$('.project-'+photo).addClass('active');
					$('.bg').removeClass('active');
					$('.bg-'+photo).addClass('active');
					$('#section4 .hover-list .swiper-slide a').addClass('off');
					$(this).removeClass('off');
					$(this).addClass('active');
					$('.home-page #section4 .bg-main').hide();
					setMask();
				});

				var news_swiper = new Swiper('#news-slider.swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					direction: 'vertical',
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					centeredSlides: true,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {
						767: {
							direction: 'horizontal',
							slidesPerView: 1.25,
							centeredSlides: false,
							initialSlide: 1,
						}
					},
				});

				$(window).on("resize orientationchange", function(){
				    var ww = document.documentElement.clientWidth;
				    var $el = $(news_swiper.$el);
				    if (ww > 767) {
						$el.removeClass("swiper-container-horizontal").addClass("swiper-container-vertical");
					}
				    else {
						$el.removeClass("swiper-container-vertical").addClass("swiper-container-horizontal");
					}
				    news_swiper.update();
				    $('#news-slider .swiper-slide').removeAttr("style");
				});

				$('#section5 #news-slider .prev').on('click', function (event){
					event.preventDefault();
					news_swiper.slidePrev();
				});
				$('#section5 #news-slider .next').on('click', function (event){
					event.preventDefault();
					news_swiper.slideNext();
				});

				$('#section6 .hover-list li a').on('mouseenter', function(){
					var photo = $(this).data('hover');
					$('.purple-box').removeClass('active');
					$('.purple-box-'+photo).addClass('active');
					$('#section6 .hover-list li a').addClass('off');
					$(this).removeClass('off');
					$(this).addClass('active');
				});

				$('#section6 .boxes-cnt').on('mouseleave', function(){
					$('.purple-box').removeClass('active');
					$('.purple-box-0').addClass('active');
					$('#section6 .hover-list li a').removeClass('off');
				});

				$('#section6 .hover-list li a').on('click', function (event){
					event.preventDefault();
				});

				$('.mobile-projects .toggle').on('click', function (event){
					event.preventDefault();
					if ($(this).hasClass('active')){
						$(this).removeClass('active');
						$(this).next().slideUp(400);
					} else {
						$(this).addClass('active');
						$(this).next().slideDown(400);
					}
				});

				var affiliate_names = [];
				var affiliate_copy = [];

				function mobileAffiliates(){
					$('.home-page #section6 .boxes-cnt .purple-box').each(function(){
						affiliate_names.push($(this).children('h3').text());
					});
					$('.mobile-affiliates .toggle').each(function (i){
						i++;
						$(this).children('.text').text(affiliate_names[i]);
					});
					$('.mobile-affiliates .purple-box-0').each(function (i){
						$(this).children('h3').text(affiliate_names[i]);
					});
					$('.home-page #section6 .boxes-cnt .purple-box').each(function(){
						affiliate_copy.push($(this).children('p').text());
					});
					$('.mobile-affiliates .purple-box').each(function (i){
						$(this).children('p').text(affiliate_copy[i]);
					});
				}

				$('.mobile-affiliates .toggle').on('click', function (event){
					event.preventDefault();
					if ($(this).hasClass('active')){
						$(this).removeClass('active');
						$(this).next().slideUp(400);
					} else {
						$(this).addClass('active');
						$(this).next().slideDown(400);
					}
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Projects page
		'page_template_template_projects': {
			init: function() {
				// JavaScript to be fired on all pages

				$('.logo').addClass('on');
				$('.hamburger').addClass('on');
				$('.nav').addClass('active');
				$('.logo').addClass('absolute');
				$('.hamburger').addClass('absolute');

				$(".animsition").animsition({
					inClass: 'fade-in',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

                $('.project-grid #projects li').addClass('on');

				$('.filter-types .current a').on('click', function (event){
					event.preventDefault();
					if ($(this).parent().hasClass('open')){
						$(this).parent().removeClass('open');
						$(this).next().slideUp(400);
					} else {
						$(this).parent().addClass('open');
						$(this).next().slideDown(400);
                        if ($(window).width() < 1300) {
                            $('.filter-bar ul.filter-location').slideUp(400);
                        }
					}
				});

				$('.location-label').on('click', function (event){
					event.preventDefault();
					if ($(this).hasClass('open')){
						$(this).removeClass('open');
						$(this).next().slideUp(400);
					} else {
						$(this).addClass('open');
						$(this).next().slideDown(400);
						$('.filter-bar ul.filter-types .current').removeClass('open');
						$('.filter-bar ul.filter-types .current > ul').slideUp(400);
					}
				});

				$(window).on('load', function(){
					var filter_locations = $('.filter-bar .filter-location li').length;
					if (filter_locations > 6){
						$('.filter-bar').addClass('dd');
					}	
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired

                function fetchProjectPosts(page) {
					var cities = [];
					var projectTypes = [];
					var btn = $('.load-more');

                    $(btn).hide();

                    if (page === 1) { $('#projects').children().remove(); }
                    
                    $('input[name="city"]:checked').each(function () {
                        cities.push($(this).val());
                    });

                    $('input[name="projectType"]:checked').each(function () {
                        projectTypes.push($(this).val());
                    });

                    $.ajax({
                        url: '/wp-content/themes/magellan-theme/lib/fetchPosts/fetchProjectPosts.php',
                        type: 'GET',
                        data: {page: page, cities: cities, projectTypes: projectTypes},
                        success: function(res) {

							try {
                                res = JSON.parse(res);
                                $('#projects').append(res.posts);

                                if ((res.maxNumPages > page) && res.maxNumPages !== 0) { $(btn).show(); }

                                if (res.postCount < 1){
                                    $('#projects').append('<li class="no-results">No results</li>');
                                }
	
							} catch (e) {}

                        }

					});
                }

				var btn = $('.load-more');
                fetchProjectPosts(1);

				$('input[type=checkbox]').change(function(){
					if ($(this).parent().hasClass('active')) {
                        $(this).parent().removeClass('active');
					} else {
                        $(this).parent().addClass('active');
					}

                    fetchProjectPosts(1);
				});

				$(btn).on('click', function(e) {
					e.preventDefault();

					var page = Number($(btn).attr('data-page'));

					page += 1;
					fetchProjectPosts(page);
					$(btn).attr('data-page', page);
				});
			}
		},


		// Social Impact page
		'page_template_template_social_impact': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.hamburger').addClass('on');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				// var menu_swiper = new Swiper('.menu-cnt .swiper-container', {
				// 	autoplay: false,
				// 	slidesPerView: 3,
				// 	loop: false,
				// 	speed: 1200,
				// 	spaceBetween: 50,
				// 	centeredSlides: true,
				// 	simulateTouch: true,
				// 	queueStartCallbacks: true,
				// 	queueEndCallbacks: true,
				// 	breakpoints: {},
				// });

		        $('.section').each(function(e){
					var section = $(this);
					var index;
		            var waypoint_section = new Waypoint({
		                element: section[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        section.addClass('ran');
		                        index = section.data('index');
		                        //menu_swiper.slideTo(index);
		                    }
		                    if (direction === 'up'){
		                        index = section.data('index') - 1;
		                        //menu_swiper.slideTo(index);
		                    }		                    
		                },
		                offset: '77%'
		            });
		        });

		        // $(window).on('scroll', function(){
		        // 	var scroll_top = $(window).scrollTop();
		        // 	var window_height = $(window).height() / 2;
		        // 	if (scroll_top < 100){
		        // 		if ($('.menu-cnt').hasClass('active')){
			    //     		$('.menu-cnt').removeClass('active');		        			
		        // 		}
		        // 	}
		        // });

				var gallery_swiper = new Swiper('#section3 .swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					loop: true,
					speed: 1200,
					spaceBetween: 20,
					centeredSlides: true,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {
						1024: {
							slidesPerView: 2,
							centeredSlides: false,
						},
						767: {
							slidesPerView: 1,
						}
					},
				});

				$('#section3 .prev').on('click', function (event){
					event.preventDefault();
					gallery_swiper.slidePrev();
				});
				$('#section3 .next').on('click', function (event){
					event.preventDefault();
					gallery_swiper.slideNext();
				});

				$('.video a, .video-btn').on('click', function (event){
					event.preventDefault();
					var video = $(this).attr('href');
					$(video).fadeIn(400);
					$('.page-overlay').fadeIn(400);
				});

				$('.video-lightbox .close').on('click', function (event){
					event.preventDefault();
					$('.video-lightbox').fadeOut(400);
					$('.page-overlay').fadeOut(400);

                    // var videoID = $(this).parent().attr('id');
					//
                    // if (videoID.length > 0) {
                    //     videoID = Number(videoID.split('-')[2]);
                    //     var videoFrame = $('.video-lightbox iframe[src*="vimeo"]')[videoID];
					//
                    //     if (videoFrame.length > 0) {
                    //         var src = videoFrame.attr('src');
                    //         // videoFrame.attr('src', '');
                    //         // videoFrame.attr('src', src);
                    //     }
                    // }
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Post page
		'page_template_template_post': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// 404 page
		'error404': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Contact page
		'page_template_template_contact': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$('.gform_footer:not(:has(.ico))').append('<span class="ico"></span>');

				$(document).bind('gform_post_render', function(){
					$('.gform_footer:not(:has(.ico))').append('<span class="ico"></span>');
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Default page
		'page_template_default': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					//$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					//$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$('select').not('.select-wrap > select').wrap('<div class="select-wrap"></div>');
				$('.ginput_container_fileupload:not(:has(.file-upload))').append('<div class="file-upload">Choose File <span>*</span></div>');
				$('.gform_footer:not(:has(.ico))').append('<span class="ico"></span>');

				$(".animsition").animsition({
					inClass: 'fade-in-right',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

				$(document).bind('gform_post_render', function(){
					$('select').not('.select-wrap > select').wrap('<div class="select-wrap"></div>');
					$('.ginput_container_fileupload:not(:has(.file-upload))').append('<div class="file-upload">Choose File <span>*</span></div>');
					$('.gform_footer:not(:has(.ico))').append('<span class="ico"></span>');
				});
			

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Single Team page
		'single_team': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$(".animsition").animsition({
					inClass: 'fade-in-right',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Single Project page
		'single_projects': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$(".animsition").animsition({
					inClass: 'fade-in-right',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Single Project Video page
        'single_post' : {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$(".animsition").animsition({
					inClass: 'fade-in-right',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Single Career page
		'single_careers': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.logo').addClass('absolute');
					$('.hamburger').addClass('on');
					$('.hamburger').addClass('absolute');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$(".animsition").animsition({
					inClass: 'fade-in-right',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// News page
		'page_template_template_news': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.hamburger').addClass('on');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				$(".animsition").animsition({
					inClass: 'fade-in',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

                $('.news-grid #news li').addClass('on');

				$('.filter-bar .news-label').on('click', function (event){
					event.preventDefault();
					if ($(this).hasClass('open')){
						$(this).removeClass('open');
						$(this).next().slideUp(400);
					} else {
						$(this).addClass('open');
						$(this).next().slideDown(400);
					}
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired

				function fetchNewsPosts(page) {

					var newPostCats = [];
					var btn = $('.load-more');

					btn.hide();
                    if (page === 1) {$('#news').children().remove();}

                    $('input[name="news"]:checked').each(function () {
                        newPostCats.push($(this).val());
                    });

                    var data = {page: page, cats: newPostCats};

					$.ajax({
						url: '/wp-content/themes/magellan-theme/lib/fetchPosts/fetchNewsPosts.php',
						type: 'GET',
						data: data,
						success: function(res) {

							try {
								var anchor = $('#news');
								res = JSON.parse(res);
								$(anchor).append(res.posts);

								if ((res.maxNumPages > page) && res.maxNumPages !== 0) { $(btn).show(); }

                                if (res.postCount < 1) {
                                    $(anchor).append('<li class="no-results">No results</li>');
                                }
	
							} catch (e) {}
						}
					});
				}

				fetchNewsPosts(1);

                $('input[type=checkbox]').change(function(){

                    if ($(this).parent().hasClass('active')) {
                        $(this).parent().removeClass('active');
                    } else {
                        $(this).parent().addClass('active');
                    }

                    fetchNewsPosts(1);
				});

                var loadMore = $('.load-more');

                $(loadMore).on('click', function(e) {
                	e.preventDefault();

                	var page = Number($(loadMore).attr('data-page')) + 1;
                	fetchNewsPosts(page);

                	$(loadMore).attr('data-page', page);
				});
			}
		},


		// About page
		'page_template_template_about': {
			init: function() {
				// JavaScript to be fired on all pages

				$(".animsition").animsition({
					inClass: 'fade-in',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

				var menu_swiper = new Swiper('.menu-cnt .swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					loop: false,
					speed: 1200,
					spaceBetween: 50,
					centeredSlides: true,
					simulateTouch: true,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {},
				});

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.hamburger').addClass('on');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

		        $('.section').each(function(e){
					var section = $(this);
					var index;
		            var waypoint_section = new Waypoint({
		                element: section[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        section.addClass('ran');
		                        index = section.data('index');
		                        menu_swiper.slideTo(index);
		                    }
		                    if (direction === 'up'){
		                        index = section.data('index') - 1;
		                        menu_swiper.slideTo(index);
		                    }		                    
		                },
		                offset: '77%'
		            });
		        });

		        $(window).on('scroll', function(){
		        	var scroll_top = $(window).scrollTop();
		        	var window_height = $(window).height() / 2;
		        	if (scroll_top < 100){
		        		if ($('.menu-cnt').hasClass('active')){
			        		$('.menu-cnt').removeClass('active');		        			
		        		}
		        	}
		        });

		        $('#section2').each(function(e){
		            var section2 = $(this);
		            var waypoint_section2 = new Waypoint({
		                element: section2[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        $('.menu-cnt').addClass('active');
		                    }
		                },
		                offset: '50%'
		            });
		        });

		        $('.awards-wrapper .awards-tabs ul li a').on('click', function (event){
		        	event.preventDefault();
		        	var year = $(this).data('year');
		        	$('.award-tab').removeClass('active');
		        	$('.award-tab-'+year).addClass('active');
		        	$('.awards-wrapper .awards-tabs ul li a').removeClass('active');
		        	$(this).addClass('active');
		        });

				var awards_swiper1 = new Swiper('#awards-1.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-1',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-1 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper1.slidePrev();
				});   	
				$('#nav-1 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper1.slideNext();
				});

				var slides1 = $('#about-1 .swiper-slide').length;
				if (slides1 < 1){
					$('#nav-1').hide();
				}

				var awards_swiper2 = new Swiper('#awards-2.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-2',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-2 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper2.slidePrev();
				});   	
				$('#nav-2 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper2.slideNext();
				});

				var slides2 = $('#about-2 .swiper-slide').length;
				if (slides2 < 1){
					$('#nav-2').hide();
				}

				var awards_swiper3 = new Swiper('#awards-3.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-3',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-3 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper3.slidePrev();
				});   	
				$('#nav-3 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper3.slideNext();
				});

				var slides3 = $('#about-3 .swiper-slide').length;
				if (slides3 < 1){
					$('#nav-3').hide();
				}

				var awards_swiper4 = new Swiper('#awards-4.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-4',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-4 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper4.slidePrev();
				});   	
				$('#nav-4 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper4.slideNext();
				});

				var slides4 = $('#about-4 .swiper-slide').length;
				if (slides4 < 1){
					$('#nav-4').hide();
				}

				var awards_swiper5 = new Swiper('#awards-5.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-5',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-5 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper5.slidePrev();
				});   	
				$('#nav-5 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper5.slideNext();
				});

				var slides5 = $('#about-5 .swiper-slide').length;
				if (slides5 < 1){
					$('#nav-5').hide();
				}

				var awards_swiper6 = new Swiper('#awards-6.swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination-6',
						type: 'fraction',
					},
					breakpoints: {},
				});	

				$('#nav-6 .prev').on('click', function(event){
					event.preventDefault();
					awards_swiper6.slidePrev();
				});   	
				$('#nav-6 .next').on('click', function(event){
					event.preventDefault();
					awards_swiper6.slideNext();
				});

				var slides6 = $('#about-6 .swiper-slide').length;
				if (slides6 < 1){
					$('#nav-6').hide();
				}

				var news_swiper = new Swiper('#news-slider.swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					direction: 'vertical',
					loop: true,
					speed: 1200,
					spaceBetween: 0,
					centeredSlides: true,
					simulateTouch: true,
					loopAdditionalSlides:2,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {
						767: {
							direction: 'horizontal',
							slidesPerView: 1.25,
							centeredSlides: false,
							initialSlide: 1,
						}						
					},
				});

				$('#section7 #news-slider .prev').on('click', function (event){
					event.preventDefault();
					news_swiper.slidePrev();
				});
				$('#section7 #news-slider .next').on('click', function (event){
					event.preventDefault();
					news_swiper.slideNext();
				});

				var slides7 = $('#about-7 .swiper-slide').length;
				if (slides7 < 1){
					$('#nav-7').hide();
				}

				$(window).on("resize orientationchange", function(){
				    var ww = document.documentElement.clientWidth;
				    var $el = $(news_swiper.$el);
				    if (ww > 767) {
						$el.removeClass("swiper-container-horizontal").addClass("swiper-container-vertical");
					}
				    else {
						$el.removeClass("swiper-container-vertical").addClass("swiper-container-horizontal");
					}
				    $('#news-slider .swiper-slide').removeAttr("style");
				    news_swiper.update();
				});

				$('#section3 .hover-links li a').on('mouseenter', function (event){
					event.preventDefault();
					var photo = $(this).data('hover'); 
					$('.photos-cnt').addClass('active');
					$('.photo-'+photo).addClass('active');
					$('#section3 .hover-links li a').addClass('off');
					$(this).removeClass('off');
					$(this).addClass('active');
				}).on('mouseleave', function(){
					$('.photos-cnt').removeClass('active');
					$('.photo').removeClass('active');
					$('#section3 .hover-links li a').removeClass('off');
					$('#section3 .hover-links li a').removeClass('active');
				});
				
				$('#section3 .hover-links li a').on('click', function (event){
					event.preventDefault();
					if ($(window).width() < 769){
						$('.about-page #section3 .photos-cnt .photo').removeClass('active');
						var photo = $(this).data('hover'); 
						$('.photo-'+photo).addClass('active');
					}
				});

				if ($(window).width() < 769){
					$('#section3 .hover-links li a').addClass('off');
					$('#section3 .hover-links li:first-child a').removeClass('off');
					$('#section3 .hover-links li:first-child a').addClass('active');
					$('.about-page #section3 .photos-cnt').addClass('active');
					$('.about-page #section3 .photos-cnt .photo-1').addClass('active');
				}

				$('.open-video').on('click', function (event){
					event.preventDefault();
					$('.video-lightbox').fadeIn(400);
					$('.page-overlay').fadeIn(400);
				});

				$('.page-overlay').on('click', function (event){
					event.preventDefault();
					$('.video-lightbox').fadeOut(400);
					$('.page-overlay').fadeOut(400);
					var vid = $('.video-lightbox iframe[src*="vimeo"]');
					if (vid.length > 0) {
						var src = vid.attr('src');
						vid.attr('src', '');
						vid.attr('src', src);
					}
				});

				$('.video-lightbox .close').on('click', function (event){
					event.preventDefault();
					$('.video-lightbox').fadeOut(400);
					$('.page-overlay').fadeOut(400);
					var vid = $('.video-lightbox iframe[src*="vimeo"]');
					if (vid.length > 0) {
						var src = vid.attr('src');
						vid.attr('src', '');
						vid.attr('src', src);
					}
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


		// Careers page
		'page_template_template_careers': {
			init: function() {
				// JavaScript to be fired on all pages

				setTimeout(function(){
					$('.hero').addClass('active');
					$('.hero .overlay').addClass('active');
					$('.logo').addClass('on');
					$('.hamburger').addClass('on');
					$('.nav').addClass('active');
					$('#scrollpage').addClass('active');
				}, 400);

				var menu_swiper = new Swiper('.menu-cnt .swiper-container', {
					autoplay: false,
					slidesPerView: 3,
					loop: false,
					speed: 1200,
					spaceBetween: 50,
					centeredSlides: true,
					simulateTouch: true,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					breakpoints: {},
				});

		        $('.section').each(function(e){
					var section = $(this);
					var index;
		            var waypoint_section = new Waypoint({
		                element: section[0],
		                handler: function(direction) {
		                    if (direction === 'down'){
		                        section.addClass('ran');
		                        index = section.data('index');
		                        menu_swiper.slideTo(index);
		                    }
		                    if (direction === 'up'){
		                        index = section.data('index') - 1;
		                        menu_swiper.slideTo(index);
		                    }		                    
		                },
		                offset: '77%'
		            });
		        });

		        $(window).on('scroll', function(){
		        	var scroll_top = $(window).scrollTop();
		        	var window_height = $(window).height() / 2;
		        	if (scroll_top < 100){
		        		if ($('.menu-cnt').hasClass('active')){
			        		$('.menu-cnt').removeClass('active');		        			
		        		}
		        	}
		        });

				$(".animsition").animsition({
					inClass: 'fade-in',
					outClass: 'fade-out-right',
					inDuration: 1500,
					outDuration: 800,
					linkElement: '.animsition-link',
					// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
					loading: true,
					loadingParentElement: 'body', //animsition wrapper element
					loadingClass: 'animsition-loading',
					loadingInner: '', // e.g '<img src="loading.svg" />'
					timeout: false,
					timeoutCountdown: 5000,
					onLoadEvent: true,
					browser: [ 'animation-duration', '-webkit-animation-duration'],
					// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
					// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
					overlay : false,
					overlayClass : 'animsition-overlay-slide',
					overlayParentElement : 'body',
					transition: function(url){ window.location.href = url; }
				});

				var careers_swiper = new Swiper('#section2 .swiper-container', {
					autoplay: false,
					slidesPerView: 1,
					loop: false,
					speed: 1200,
					spaceBetween: 0,
					simulateTouch: true,
					queueStartCallbacks: true,
					queueEndCallbacks: true,
					pagination: {
						el: '.pagination',
						type: 'fraction',
					},					
					breakpoints: {},
				});

				$('#section2 .prev').on('click', function (event){
					event.preventDefault();
					careers_swiper.slidePrev();
				});
				$('#section2 .next').on('click', function (event){
					event.preventDefault();
					careers_swiper.slideNext();
				});

				$(window).on('load', function(){
					var items = $('#section2 .swiper-slide').length;
					if (items <= 1){
						$('#section2 .pagination').hide();
						$('.careers-page #section2 .prev').hide();
						$('.careers-page #section2 .next').hide();
					}	
					
				});

				$('.careers-page #section2 .swiper-container .swiper-slide a').on('mouseenter', function(){
					$('.careers-page #section2 .swiper-container .swiper-slide a').addClass('off');
					$(this).removeClass('off');
				}).on('mouseleave', function(){
					$('.careers-page #section2 .swiper-container .swiper-slide a').removeClass('off');
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},


	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
